__turbopack_context__.v({
  "reference": "eygVkG_reference",
  "shimmer": "eygVkG_shimmer",
  "text-bar-sweep": "eygVkG_text-bar-sweep",
});
